

export const customThemeNameOrUndefined = (): string | null => {
    return localStorage.getItem('custom-theme');
};


export const customThemeNameOrUndefined = (): string | null => {
    return localStorage.getItem('custom-theme');
};
